import { render, staticRenderFns } from "./CatAssets.vue?vue&type=template&id=96658416&scoped=true&"
import script from "./CatAssets.vue?vue&type=script&lang=js&"
export * from "./CatAssets.vue?vue&type=script&lang=js&"
import style0 from "./CatAssets.vue?vue&type=style&index=0&id=96658416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96658416",
  null
  
)

export default component.exports